module.exports = __webpack_public_path__ + "RobotoLight.c15ac95ca33e2e13faef.svg";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoLight.svg
// module id = ../../../../../src/fonts/RobotoLight.svg
// module chunks = 3